const buttonList = [
    {
        type: 'text',
        class: 'bigData-btn-ltc-add',
        icon: 'el-icon-circle-plus-outline',
        label: '新增',
        size: 'small',
        event: 'add',
        ifHas: '07080014'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '保存',
        size: 'small',
        event: 'save',
        loading: false,
        ifHas: '07080014'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '导出',
        size: 'small',
        event: 'export',
        loading: false,
        ifHas: '07080015'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-save',
        icon: 'el-icon-circle-check',
        label: '导入',
        size: 'small',
        event: 'upload',
        loading: false,
        ifHas: '07080016'
    },
    {
        type: 'text',
        class: 'bigData-btn-ltc-delete',
        icon: 'el-icon-delete',
        label: '删除',
        size: 'small',
        event: 'delete',
        loading: false,
        ifHas: '07080017'
    }
];

const config = {
    configuration: true,
    buttonList: buttonList,
    table:
    {
        selectBtn: true,
        tableCut: true,
        clickModify: true,
        height: 'calc(30vh)',
        leftOperation: true,
        columns: [],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'mini',
                event: 'edit'
            }
        ],
        leftWidth: 60
    },
    page: {
        // layout: 'total, sizes, prev, pager, next, jumper',
        layout: 'total,sizes,prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 100, 500]
    }
};

export const columnMap = {
    // 货物运输服务
    'CBS': [
        {
            label: '运输工具种类',
            prop: 'transportType',
            type: 'select',
            popperAppendToBody: true,
            'optionNum': 'BMS_TRANSPORT_TYPE',
            width: '150',
            mustFill: true,
            require: true
        },
        {
            label: '运输工具牌号',
            prop: 'transportPlateNo',
            width: '150',
            mustFill: false,
            require: true,
            defaultValue: ''
        },
        {
            label: '起运地',
            prop: 'placeFromAddress',
            width: '150',
            mustFill: false,
            require: true,
            defaultValue: ''
        },
        {
            label: '到达地',
            prop: 'placeToAddress',
            width: '150',
            mustFill: false,
            require: true,
            defaultValue: ''
        },
        {
            label: '运输货物名称',
            prop: 'goodsName',
            width: '150',
            mustFill: true,
            require: true
        }
    ],
    // 不动产经营租赁服务
    'REBLS': [
        {
            label: '不动产地址',
            prop: 'subStr2',
            labelCn: 'realEstateAddress',
            inputReadonly: true,
            placement: 'right-end',
            'filterable': true,
            'minLayers': 0,
            'config': {
                'checkStrictly': true
            },
            'type': 'addressCascader',
            mustFill: true,
            'require': true,
            'width': '100'
        },
        {
            label: '详细地址',
            prop: 'detailedAddress',
            placeholder: '详细地址',
            'require': true,
            mustFill: true,
            'width': '150'
        },
        {
            'label': '租赁期起止',
            'prop': 'rentStartAndEndDate',
            'require': true,
            'width': '140',
            'type': 'el-date-picker',
            'datePickerType': 'datetimerange',
            'mustFill': true
            // 'format': 'yyyy-MM-dd'
            // 'textFormat': 'yyyy-MM-dd'
        },
        {
            label: '跨地（市）标志',
            prop: 'crossCityFlag',
            type: 'select',
            // 'optionNum': 'BMS_YSE_NO',
            options: [
                {
                    label: '是',
                    value: 1
                },
                {
                    label: '否',
                    value: 0
                }
            ],
            width: '60',
            mustFill: true,
            require: true
        }
    ]
};

export const saveDataTemp = {
    'jobId': '',
    'transportType': '',
    'transportPlateNo': '',
    'placeFromAddress': '',
    'placeToAddress': '',
    'goodsName': '',
    'realEstateAddress': '',
    'crossCityFlag': '',
    'recVer': '',
    'recStatus': '',
    'creator': '',
    'modifier': '',
    'createTime': '',
    'modifyTime': ''
};

export const changeConfig = (data = [], props = [], obj) => data.forEach(el => props.includes(el.prop) && (el = { ...el, ...obj }));

export const showActionBar = (flag) => {
    config.buttonList = flag ? buttonList : false;
};

export default config;
